import { t } from "../../translations";
import "../styles/terms-services.css";

const FoodSafety = ({ lang }) => {
  return (
    <div className="servicesTerms_body">
      <h1>{t("community_guidelines.page_title", lang)}</h1>

      <p>{t("communityGuidelines.servicesTerms", lang)}</p>

      <h2 className="h2-title">
        {t("communityGuidelines.supplementarySafetyGuidelines.title", lang)}
      </h2>

      <ul>
        <li>
          {t(
            "communityGuidelines.supplementarySafetyGuidelines.refrigerateFoods",
            lang
          )}
        </li>
        <li>
          {t(
            "communityGuidelines.supplementarySafetyGuidelines.packageFoods",
            lang
          )}
        </li>
        <li>
          {t(
            "communityGuidelines.supplementarySafetyGuidelines.discloseIngredients",
            lang
          )}
        </li>
        <li>
          {t(
            "communityGuidelines.supplementarySafetyGuidelines.certifyIncome",
            lang
          )}
        </li>
        <li>
          {t(
            "communityGuidelines.supplementarySafetyGuidelines.acceptSickness",
            lang
          )}
        </li>
      </ul>

      <h2 className="h2-title">
        {t("communityGuidelines.planningAndGuidanceOfMenus.title", lang)}
      </h2>

      <ul>
        <li>
          {t(
            "communityGuidelines.planningAndGuidanceOfMenus.comprehendAndRecognize",
            lang
          )}
        </li>
        <li>
          {t(
            "communityGuidelines.planningAndGuidanceOfMenus.determinePrice",
            lang
          )}
        </li>
        <li>
          {t(
            "communityGuidelines.planningAndGuidanceOfMenus.ensureQuality",
            lang
          )}
        </li>
        <li>
          {t(
            "communityGuidelines.planningAndGuidanceOfMenus.scheduleOrders",
            lang
          )}
        </li>
        <li>
          {t(
            "communityGuidelines.planningAndGuidanceOfMenus.upholdCommitments.text",
            lang
          )}
        </li>
        <li>
          {t(
            "communityGuidelines.planningAndGuidanceOfMenus.submitChanges.text",
            lang
          )}
        </li>
      </ul>

      <h2 className="h2-title">
        {t("communityGuidelines.suppliesAndPackaging.title", lang)}
      </h2>

      <ul>
        <li>
          {t("communityGuidelines.suppliesAndPackaging.responsible.text", lang)}
        </li>
        <li>{t("communityGuidelines.suppliesAndPackaging.ensure", lang)}</li>
        <li>{t("communityGuidelines.suppliesAndPackaging.follow", lang)}</li>
      </ul>

      <h2 className="h2-title">
        {t("communityGuidelines.mediaRelease.title", lang)}
      </h2>

      <p>{t("communityGuidelines.mediaRelease.accept.text", lang)}</p>

      <h2 className="h2-title">
        {t("communityGuidelines.amendments.title", lang)}
      </h2>

      <p>{t("communityGuidelines.amendments.accept", lang)}</p>

      <h2 className="h2-title">
        {t("communityGuidelines.violations.title", lang)}
      </h2>

      <p>{t("communityGuidelines.violations.accept", lang)}</p>

      <p>
        <strong>{t("communityGuidelines.last_revised", lang)}</strong>
      </p>
    </div>
  );
};

export default FoodSafety;
